import React , {useState} from 'react'
import { makeStyles } from '@mui/styles';
import { Box, Typography } from '@mui/material';
import CustomButton from 'components/CustomButton';
import StartAssessmentDialog from 'dialogs/StartAssessmentDialog';

const useStyles = makeStyles((theme) => ({
  container : {
    width : '100%',
    height : '124px',
    display : 'flex',
    justifyContent : 'space-between',
    alignItems : 'center',
    border : `2px solid ${theme.palette.neutral['clr-200']}`,
    borderRadius : theme.spacing(2),
    backgroundColor : theme.palette.shades['clr-white-900'],
    padding : theme.spacing(8)
  }
}))

const Reattempt = ({challenge}) => {
  const classes = useStyles();
  
  const [openAssessmentDialog , setOpenAssessmentDialog] = useState(false);

  return (
    <Box className={classes.container}>
      <Box display='flex' gap='16px' alignItems='center'>
        <img 
          src='https://assets.languify.in/gifs/rocket.gif'
          width={108}
          height={60}
          alt='rocket'
        />
        <Box display='flex' flexDirection='column' gap='8px'>
          <Typography variant='h4-medium' color='neutral.clr-900'>
            Reattempts significantly improve overall score.
          </Typography>
          <Typography variant='h6-medium' color='neutral.clr-600'>
            Give this another shot!
          </Typography>
        </Box>
      </Box>
      <CustomButton onClick={() => setOpenAssessmentDialog(true)}>
        Reattempt
      </CustomButton>
      <StartAssessmentDialog
        onClose={() => setOpenAssessmentDialog(false)}
        open={openAssessmentDialog}
        template={{ _id : challenge?._id , name : challenge?.title}}
        codingInterview={true}
      />
    </Box>
  )
}

export default Reattempt